<template>
  <div>
    <modal
      :exibir="exibir"
      @fechar="fecharModal"
      :titulo="titulo"
      :campos="$refs"
      id="ModalEndereco"
    >
      <b-container>
        <b-row class="flex-column flex-sm-row">
          <input-mask
            class="col-md-6"
            type="text"
            v-model="formEndereco.cep"
            :label="$t('PESSOAS.CEP')"
            :mask="['#####-###']"
            placeholder="Digite apenas números"
            @input="buscaDadosCEP"
          />
          <input-select-search
            class="col-md-6"
            ref="paisId"
            :label="$t(`PESSOAS.PAIS`)"
            :options="gets.listaPais"
            v-model="formEndereco.paisId"
            :isDisabled="disabled.pais"
          />
          <input-select-search
            class="col-md-6"
            ref="estadoId"
            :label="$t(`PESSOAS.ESTADO`)"
            placeholder="Digite ou selecione"
            :options="gets.listaEstado"
            :isDisabled="disabled.estado"
            v-model="formEndereco.estadoId"
            required
          />
          <input-select-search
            class="col-md-6"
            ref="municipioId"
            :label="$t(`PESSOAS.MUNICIPIO`)"
            placeholder="Digite ou selecione"
            :options="gets.listaMunicipio"
            :isDisabled="disabled.municipio"
            v-model="formEndereco.municipioId"
            required
          />
          <input-text
            class="col-md-6"
            ref="bairro"
            :label="$t('PESSOAS.BAIRRO')"
            placeholder="Digite aqui"
            v-model="formEndereco.bairro"
            required
          />
          <input-text
            class="col-md-6"
            ref="logradouro"
            :label="$t('PESSOAS.LOGRADOURO')"
            placeholder="Digite aqui"
            v-model="formEndereco.logradouro"
            required
          />
          <input-text
            ref="numero"
            class="col-md-6"
            :label="$t('PESSOAS.NUMERO')"
            placeholder="Digite aqui"
            v-model="formEndereco.numero"
            required
          />
          <input-text
            class="col-md-6"
            :label="$t('PESSOAS.COMPLEMENTO')"
            placeholder="Campo opcional"
            v-model="formEndereco.complemento"
          />
          <input-select-search
            class="col-md-6"
            ref="tipoEndereco"
            :label="$t(`PESSOAS.TIPO_ENDERECO`)"
            placeholder="Digite ou selecione"
            :options="gets.listaTipoEndereco"
            @input="obterDescricaoTipoEndereco"
            v-model="formEndereco.tipoEndereco"
            required
          />

          <b-form-group class="col-sm-12">
            <b-form-checkbox
              v-model="formEndereco.principal"
              :value="true"
              :unchecked-value="false"
            >
              <label>{{ $t('PESSOAS.ENDERECO_PRINCIPAL') }}</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <b-button variant="secondary" @click="fecharModal">{{
            $t('GERAL.FECHAR')
          }}</b-button>
          <b-button variant="primary" @click="salvar">{{
            $t('GERAL.SALVAR')
          }}</b-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import { validationMixin } from 'vuelidate';
import { v4 as uuidv4 } from 'uuid';

// Services:
import Endereco from '@/common/models/pessoas/Endereco.js';
import EnderecoService from '@/common/services/endereco/endereco.service';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';
import PessoaService from '@/common/services/pessoa/pessoa.service';

// Components:
import Modal from '@/components/modal/Modal.vue';
import { InputSelectSearch, InputText, InputMask } from '@/components/inputs';

export default {
  mixins: [validationMixin],
  components: {
    Modal,
    InputSelectSearch,
    InputText,
    InputMask,
  },
  props: {
    exibir: { type: Boolean, default: false },
    form: { type: Object, default: Object },
    endereco: { type: Object, default: Object },
    id: { type: String, default: null },
  },
  data() {
    return {
      formEndereco: [{ tipoEnderecoDescricao: '' }],
      dadosPesquisaCEP: [],
      idQuerry: this.$route.params.id,
      gets: {
        brasil: [],
        listaPais: [],
        listaEstado: [],
        listaMunicipio: [],
        listaTipoEndereco: [],
      },
      disabled: {
        pais: true,
        estado: false,
        municipio: false,
      },
    };
  },
  mounted() {
    this.getPaises();
    this.getTipoEndereco();
  },
  computed: {
    titulo() {
      return !this.endereco.id
        ? this.$t('GERAL.CADASTRAR')
        : this.$t('GERAL.EDITAR');
    },
  },
  watch: {
    'formEndereco.estadoId': 'getMunicipios',
    exibir: 'verificaNovoOuEditar',
  },
  methods: {
    obterDescricaoTipoEndereco() {
      const resultado = this.gets.listaTipoEndereco.filter(
        ({ id }) => id === this.formEndereco.tipoEndereco
      );
      this.formEndereco.tipoEnderecoDescricao = resultado[0]?.descricao;
    },
    verificaNovoOuEditar() {
      this.endereco.id
        ? (this.formEndereco = this.endereco)
        : setTimeout(() => {
            helpers.resetarValidacao(this.$refs);
            this.formEndereco = new Endereco({});
          }, 10);
      this.getPaises();
      this.getEstados();
      this.getMunicipios();
    },
    getTipoEndereco() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('tipo-enderecos')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.descricao,
          }));
          this.gets.listaTipoEndereco = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getPaises() {
      this.$store.dispatch(START_LOADING);
      EnderecoService.buscarNacionalidades()
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.nome,
          }));
          this.gets.listaPais = data;
          this.getBrasil(); // atualmente fazemos busca de estado BR então salvo o BR direto no this.gets.brasil
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getBrasil() {
      this.gets.listaPais.forEach((element) => {
        if (element.nome == 'Brasil') {
          this.formEndereco.paisId = element.id;
          return (this.gets.brasil = element);
        }
      });
    },
    getEstados() {
      this.$store.dispatch(START_LOADING);
      EnderecoService.buscarEstados(this.gets.brasil.id)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.nome,
          }));
          this.gets.listaEstado = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getMunicipios() {
      this.$store.dispatch(START_LOADING);
      if (this.formEndereco.estadoId)
        EnderecoService.buscarMunicipios(this.formEndereco.estadoId)
          .then(({ data }) => {
            data = data.map((row) => ({
              ...row,
              value: row.id,
              text: row.nome,
            }));
            this.gets.listaMunicipio = data;
            if (this.dadosPesquisaCEP) {
              this.encontrarMunicipio();
            }
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
    },
    encontrarMunicipio() {
      this.gets.listaMunicipio.forEach((element) => {
        if (element.nome == this.dadosPesquisaCEP.localidade) {
          this.formEndereco.municipioId = element.id;
        }
      });
    },
    async buscaDadosCEP() {
      if (this.formEndereco.cep.length != 9) return;
      this.$store.dispatch(START_LOADING);

      await EnderecoService.buscarInformacoesCep(this.formEndereco.cep)
        .then((endereco) => {
          this.formEndereco = {
            ...this.formEndereco,
            ...endereco,
            logradouro: endereco.logradouro || this.formEndereco.logradouro,
            bairro: endereco.bairro || this.formEndereco.bairro,            
          };
          this.disabled.estado = false;
          this.disabled.municipio = false;
        })
        .catch((error) => {
          this.formEndereco = new Endereco({});
          mensagem.warning(this.$t('CAMPOS_VALIDACAO.CEP_INEXISTENTE'), error);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    verificaPrincipal() {
      this.form.enderecos.forEach((element, index) => {
        element.index = index;
        if (
          this.formEndereco.principal === true &&
          element.principal === true &&
          this.formEndereco.index !== element.index
        ) {
          element.principal = false;
        }
      });
    },
    criarEnderecoAtribuidoPessoa(endereco) {
      this.$store.dispatch(START_LOADING);
      PessoaService.criarEndereco({ ...endereco, entidadeId: this.id })
        .then(({ data }) => {
          this.form.enderecos = data.data.enderecos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    atualizarEndereco(endereco, edicaoLocal) {
      if (!edicaoLocal) {
        this.$store.dispatch(START_LOADING);
        PessoaService.atualizarEndereco({ ...endereco, entidadeId: this.id })
          .then(({ data }) => {
            this.form.enderecos = data.data.enderecos;
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
        return;
      }

      const { index } = endereco;
      this.form.enderecos[index] = endereco;
      this.form.enderecos = this.form.enderecos.filter((item) => item);
    },
    // FUNÇÕES MODAL:
    fecharModal() {
      this.disabled.estado = false;
      this.disabled.municipio = false;
      this.$emit('fechar');
    },
    // FUNÇÕES CRUD:
    salvar() {
      if (!this.idQuerry) this.formEndereco.id = uuidv4();
      if (!this.validarFormulario()) return;

      // se for um novo endereço:
      if (!this.endereco.id) {
        this.id
          ? this.criarEnderecoUserExistente()
          : this.criarEnderecoNovoUser();
        this.fecharModal();
        return;
      }
      // se for a edição de um endereço:
      else if (this.endereco.id) {
        this.id
          ? this.editarEnderecoUserExistente()
          : this.editarEnderecoNovoUser();
        this.fecharModal();
        return;
      }
    },
    criarEnderecoNovoUser() {
      this.form.enderecos.push(this.formEndereco);
      this.verificaPrincipal();
    },
    criarEnderecoUserExistente() {
      this.criarEnderecoAtribuidoPessoa(this.formEndereco);
    },
    editarEnderecoNovoUser() {
      this.atualizarEndereco(this.formEndereco, true);
      this.verificaPrincipal();
    },
    editarEnderecoUserExistente() {
      this.atualizarEndereco(this.formEndereco);
      this.fecharModal();
    },
    // FUNÇÕES AUXILIARES:
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
  },
};
</script>
